import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { actions } from '../../actions/actionsWrapper';
import { IBaseResponeModel } from './../../../models/response/base-response';
import { IBaiVietDeleteStart, IBaiVietLoadStart, eBaiVietActionTypeIds } from './../../action-types/bai-viet/IBaiVietActionTypes';

const appBaiVietApi = apiWrapper.appBaiViet;

export function* baiVietSaga(): any {
    yield takeLatest(eBaiVietActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eBaiVietActionTypeIds.DELETE_START, deleteWorker)

}

function* loadWorker(action: IBaiVietLoadStart): any {

    const res: IBaseResponeModel = yield call([appBaiVietApi, appBaiVietApi.SelectBySchoolAsync], action.payload)
    if (res.is_success) {
        yield put(actions.baiViet.loadSuccess(res.data))
    } else {
        yield put(actions.baiViet.loadError(res.message || "Không tải được bài viết"))
    }
}

function* deleteWorker(action: IBaiVietDeleteStart): any {
    const res: IBaseResponeModel = yield call([appBaiVietApi, appBaiVietApi.DeleteMultiple], action.payload)
    if (res.is_success) {
        yield put(actions.baiViet.deleteSuccess())
    } else {
        yield put(actions.baiViet.deleteError(res.message || "Không xóa được bài viết"))
    }
}
